import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/** Cross-dissolve between two photos, tied to scroll. */
export const CinematicDissolve = ({ from, to, label, num }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const fromOpacity = useTransform(scrollYProgress, [0, 0.5, 1], [1, 0.4, 0]);
  const toOpacity = useTransform(scrollYProgress, [0, 0.5, 1], [0, 0.4, 1]);
  const fromScale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);
  const toScale = useTransform(scrollYProgress, [0, 1], [1.12, 1]);
  const labelOpacity = useTransform(scrollYProgress, [0.3, 0.5, 0.7], [0, 1, 0]);
  const labelScale = useTransform(scrollYProgress, [0.3, 0.5, 0.7], [0.9, 1, 1.05]);

  return (
    <section ref={ref} className="relative h-screen w-full overflow-hidden bg-black cinematic-grain">
      <motion.img
        src={from}
        alt=""
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ opacity: fromOpacity, scale: fromScale }}
      />
      <motion.img
        src={to}
        alt=""
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ opacity: toOpacity, scale: toScale }}
      />
      <div className="absolute inset-0 bg-black/40" />

      {label && (
        <motion.div
          className="absolute inset-0 flex items-center justify-center"
          style={{ opacity: labelOpacity, scale: labelScale }}
        >
          <div className="text-center">
            {num && (
              <span className="chapter-num block mb-6 tracking-[0.6em]">{num}</span>
            )}
            <div className="cinematic-serif-italic text-[#D9C08E] text-4xl md:text-5xl lg:text-6xl leading-tight">
              {label}
            </div>
          </div>
        </motion.div>
      )}
    </section>
  );
};

export default CinematicDissolve;
